// extracted by mini-css-extract-plugin
module.exports = {"trust":"TrusBox_trust__L2NMi"};